import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const LegacyModernizationPage: React.FC = () => {
  return <ServicePageTemplate slug="legacy-modernization" />;
};

export default LegacyModernizationPage;
